import { FC } from 'react';

import Loader from '../../../Loader';
import TitleBlock from '../../../TitleBlock';
import { SubscriptionHistoryItemProps } from '../SubscriptionHistoryItem';
import SubscriptionHistoryList from '../SubscriptionHistoryList';

import {
  SubscriptionHistoryEmptyBlock,
  SubscriptionHistoryLoader
} from './Wrapper';

export type SubscriptionHistoryBlockProps = {
  list?: SubscriptionHistoryItemProps[];
  isPending?: boolean;
};

const SubscriptionHistoryBlock: FC<SubscriptionHistoryBlockProps> = ({
  list,
  isPending
}) => (
  <div>
    <TitleBlock title="Receipt History" size={'medium'} level={3} />
    {list && <SubscriptionHistoryList list={list}></SubscriptionHistoryList>}
    {!list && !isPending && (
      <SubscriptionHistoryEmptyBlock>
        No history yet
      </SubscriptionHistoryEmptyBlock>
    )}
    {isPending && (
      <SubscriptionHistoryLoader>
        <Loader color="blue" size="large" />
      </SubscriptionHistoryLoader>
    )}
  </div>
);

export default SubscriptionHistoryBlock;
